import script from "./OpenButton.vue?vue&type=script&setup=true&lang=ts"
export * from "./OpenButton.vue?vue&type=script&setup=true&lang=ts"

import "./OpenButton.vue?vue&type=style&index=0&id=87edfd7e&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-87edfd7e"]])

export default __exports__